import { IssueData, ZodIssueCode } from 'zod';
import { isUndefined } from 'utils/tsHelpers';
import { CastType } from '../../../types';

export const validateMergeParamCastTypeValue = (
  {
    value,
    castType,
  }: Partial<{
    value: string;
    castType: CastType;
  }>,
  addIssue: (arg: IssueData) => void,
) => {
  if (castType !== CastType.MERGE_PARAM) return;
  const handlebarsRegex = /\{{2}.*\}{2}/i;
  const isNotANumberValue = !!isNaN(Number(value));
  const hasInvalidRegexValue = isUndefined(value) || !handlebarsRegex.test(value.toString());
  const isInvalidMergeParamValue = isNotANumberValue && hasInvalidRegexValue; // be a number or a {{ handlebar }}
  if (isInvalidMergeParamValue) {
    addIssue({
      code: ZodIssueCode.custom,
      message: 'invalid number value with mergeParam castType',
      path: ['value'],
    });
  }
};
